import { distanceInWordsStrict } from 'date-fns'
import { IMatchupList } from './interfaces';

export default {
  MATCHUPS: (state: IGameState) => {
    return state.matchups
  },
  PERSONALISED_MATCHUPS: (state: IGameState): IMatchupList => {
    return state.personalisedMatchups
  },
  MATCHUPSPENDING: (state: IGameState) => {
    return state.listPending
  },
  NEWS: (state: IGameState) => {
    return state.newsArticles
  },
  SETTLEMENTTIME: (state: IGameState) => {
    return state.settlementTime
  },
  SETTLEMENTTIMELEFT: (state: IGameState) => {
    return (time: number) => {
      const st = state.settlementTime
      if (st) {
        return (st - time) / 1000
      }
      return 0
    }
  },
  SETTLEMENTCOUNTDOWN: (state: IGameState) => {
    
    return (time: number) => { 
      const st = state.settlementTime
      if (st && st >= time) {
        return distanceInWordsStrict(st, time)
      }
      return ''
    }
  }
};
